export default __webpack_public_path__ + "static/media/sequencer.e8a83717.svg";